<template>
    <v-card class="white border-boxGlobal">
        <v-card-title> Reporte de Costos de Inventario </v-card-title>
        <v-row class="mx-1">
        </v-row>
        <block v-if="loading"></block>
        <VersatileFilter :search="search" @emptyFilter="getEarningDetail"
            :columnsSearch="columsConfig"
            @filtered="filterHandler" :key="Reloadfilter" :useCache="true"
            @updateCache="updateCache" class="mx-3" :oneDateFilter="true"
            :columnfilterEndpoint="$API.inventoryReports.getInventoryFilterReportColumn">
                <v-checkbox v-model="search.allRecords" label="Mostrar todos los registros (sin límite de 100)"></v-checkbox>
                <InventoryCostReportTable :data="reportsData" @exporting="onExporting" />
        </VersatileFilter>
        <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
        </alerts>
    </v-card>
</template>

<script>
import { printToExcel } from "@/helpers/printToexcel";
import VersatileFilter from "@/components/VersatileFilter";
import Block from "@/components/Block";
import Alerts from "@/components/Alerts";
import InventoryCostReportTable from "./InventoryCostReportTable.vue";

export default {
    name: "InventoryCostReport",
    components: {
        Block,
        Alerts,
        VersatileFilter,
        InventoryCostReportTable,
    },
    props: ["win", "datafilter"],
    data() {
        return {
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            loading: false,
            reportsData: [],
            search: {},
            Reloadfilter: 0,
            cacheData: [],
            columsConfig: [
                {
                    name: "ID_Warehouse",
                    title: "Almacenes",
                    value: "",
                    type: "select",
                    options: [],
                },
                {
                    name: "family",
                    title: "Familia",
                    value: "",
                    type: "select",
                    options: [],
                },
                {
                    name: "category",
                    title: "Categoría",
                    value: '',
                    parent: 'family',
                    type: "select",
                    options: [],
                },
                {
                    name: "subcategory",
                    parent: 'category',
                    title: "Subcategoría",
                    value: '',
                    type: "select",
                    options: [],
                },
            ],
        };
    },
    methods: {
        mapCostoPromedio(response) {
            return response.map((item) => {
                item.CostoPromedio = item.CostoPromedio || 0;
                return item;
            });
        },
        closeAlert() {
            this.alert.show = false;
        },
        acceptAlert() {
            this.alert.show = false;
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        getEarningDetail() {
            this.loading = true;
            this.$API.inventoryReports
                .getInventoryReport()
                .then((response) => {
                    this.loading = false;
                    this.reportsData = this.mapCostoPromedio(response);
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },
        filterHandler(response) {
            this.reportsData = this.mapCostoPromedio(response);
        },
        updateCache(data) {
            this.cacheData = data;
        },
        onExporting(e) {
            printToExcel(e, "Reporte de Costos de Inventario");
        },
        assignParams() {
            if (this.datafilter) {
                this.columsConfig[0].options = this.datafilter.Warehouses;
                this.columsConfig[1].options = this.datafilter.Families;
                this.columsConfig[2].options = this.datafilter.Categories;
                this.columsConfig[3].options = this.datafilter.SubCategories;
                this.Reloadfilter += 1;
            }
        },
    },
    mounted() {
        //this.getEarningDetail();
        this.assignParams();
    },
};
</script>

<style scoped>
.btnblack {
    background-color: rgba(60, 60, 60, 1) !important;
    color: white !important;
}

.close-btn {
    color: white !important;
    position: relative !important;
    float: right !important;
}

.border {
  border-radius: 15px !important;
}
</style>
